module.exports = __webpack_public_path__ + "static/img/adoption_movie_thum_01_no_btn.c23b3f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/movie/adoption_movie_thum_01_no_btn.jpg
// module id = R2dU
// module chunks = 0